import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { createAndResizeCircImgDivs } from "./scripts/resizer";

// Import pages
import Home from "./pages/Home";
import History from "./pages/History";
import Banner from "./components/Banner";
import CapitalPlan from "./pages/CapitalPlan/CapitalPlan";
import Rebuild from "./pages/Rebuild";
import Improve from "./pages/Improve";
import Expand from "./pages/Expand";
import NextSteps from "./pages/NextSteps";

function App() {

  const handleOpenModal = (id) => {
    const modalElement = document.getElementById(id);
    if (modalElement) {
        modalElement.style.display = 'block';
        createAndResizeCircImgDivs();
        modalElement.classList.add('showing');
    }
  };

  const handleCloseModal = (id) => {
      const modalElement = document.getElementById(id);
      if (modalElement) {
          modalElement.style.display = 'none';
          modalElement.classList.remove('showing');
      }
  };
  

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home 
                    handleOpenModal={handleOpenModal}
                    handleCloseModal={handleCloseModal} />} />
        <Route path="history" element={<History />} />
        <Route path="capitalplan" element={<CapitalPlan />} />
        <Route path="rebuild" element={<Rebuild 
                    handleOpenModal={handleOpenModal}
                    handleCloseModal={handleCloseModal} />} />
        <Route path="improve" element={<Improve 
                    handleOpenModal={handleOpenModal}
                    handleCloseModal={handleCloseModal} />} />
        <Route path="/#face-challenges" element={<Banner />} />
        <Route path="expand" element={<Expand
                    handleOpenModal={handleOpenModal}
                    handleCloseModal={handleCloseModal} />} />
        <Route path="next-steps" element={<NextSteps
                    handleOpenModal={handleOpenModal}
                    handleCloseModal={handleCloseModal} />} />
      </Routes>
    </Router>
  );
}

export default App;